// packages
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
// styles
import 'font-awesome/less/font-awesome.less';
import './RelatedTransaction.less';

class EmailPopup extends Component {
  static propTypes = {
    sendDocketViaEmail: PropTypes.func,
    closePopup: PropTypes.func,
    loadingSpinner: PropTypes.bool,
  };

  static defaultProps = {
    closePopup: () => null,
    sendDocketViaEmail: () => null,
    loadingSpinner: false,
  };

  render() {
    const {
      sendDocketViaEmail,
      loadingSpinner,
    } = this.props;
    const mail_to = this.props.emails.email;
    const friendly_name = this.props.friendly_name;
    const docketNumber = this.props.docketNumber;
    const part_number = this.props.part_number;
    return (
      <div className="popup">
        <Form
      initialValues={{ mail_to, friendly_name, docketNumber, part_number }}
      onSubmit={sendDocketViaEmail}
      render={({
        handleSubmit,
        pristine,
        form,
        reset,
        submitting,
        }) => (
          <div className="popup_inner">
            <div className="title">
              <h3>Share Docket <i onClick={this.props.closePopup} className="fa fa-times-circle" style={{ float: 'right', fontSize: '16px' }} /></h3>
            </div>
            <div className="popup-body">
              <form onSubmit={handleSubmit} id="related-form">
                <label htmlFor="mail_to"> Email (separate by commas)
                <Field
                    name="mail_to"
                    component="input"
                    type="text"
                    placeholder=""
                />
                </label>
                <label htmlFor="message"> Message (optional)
                  <Field
                      name="message"
                      component="textarea"
                      rows="10"
                      cols="30"
                      type="text"
                      placeholder=""
                  />
                </label>
                <button type="submit" disabled={submitting || pristine} className="form-submit green">
                  {loadingSpinner ? <i className="fa fa-spinner fa-spin" /> : <div>Sent</div>}
                </button>
                <button
                  type="reset"
                  onClick={reset}
                  disabled={submitting}
                  className="form-reset">
                  Cancel
                </button>
              </form>
            </div>
          </div>)}
      />
      </div>
    );
  }
}

export default EmailPopup;



// WEBPACK FOOTER //
// ./src/components/case/related_transaction/EmailPopup.jsx